import StatBox from "./StatBox";
export default function StatSection(){
    return(
    <section className="bg-white py-10 w-100 shadow-sm rounded-xl max-w-6xl mx-auto mt-6 mb-6 relative z-10">
    <div className="grid grid-cols-1 md:grid-cols-3 text-center gap-6">
      <StatBox number="100+" label="Siswa Bergabung" />
      <StatBox number="10+" label="Kursus Berkualitas" />
      <StatBox number="10+" label="Mentor Berpengalaman" />
    </div>
  </section>
    )
}